/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  isVoiceMessage = false,
  contentType,
  agentStickerId,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (isVoiceMessage) {
      payload.append('is_voice_message', true);
    }
    if (contentType) {
      payload.append('content_type', contentType);
    }
    if (agentStickerId) {
      payload.append('agent_sticker_id', agentStickerId);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
      content_type: contentType,
      agent_sticker_id: agentStickerId,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    isVoiceMessage = false,
    contentType,
    agentStickerId,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        isVoiceMessage,
        contentType,
        agentStickerId,
      }),
    });
  }

  delete(conversationID, messageId, deleteScope) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`, {
      data: deleteScope ? { delete_scope: deleteScope } : undefined,
    });
  }

  editWhatsapp(conversationID, messageId, content) {
    return axios.patch(
      `${this.url}/${conversationID}/messages/${messageId}/edit_whatsapp`,
      { content }
    );
  }

  reactWhatsapp(conversationID, messageId, reaction) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/react_whatsapp`,
      { reaction }
    );
  }

  forwardWhatsapp(conversationID, messageId, targetConversationIds) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/forward_whatsapp`,
      { target_conversation_ids: targetConversationIds }
    );
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  search({ conversationId, q, since, until }) {
    return axios.get(`${this.url}/${conversationId}/messages/search`, {
      params: { q: q || undefined, since, until },
    });
  }

  getMessagesAround({ conversationId, messageId }) {
    return axios.get(`${this.url}/${conversationId}/messages`, {
      params: { around: messageId },
    });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }
}

export default new MessageApi();
